import React, {Component} from 'react';
import Icons from '../../Containers/Icons';

class MenuCenter extends Component {
  constructor(){
    super();
    this.state = {
      usr: "",
      email: ""
    }
  }
  componentWillReceiveProps() {
    this.setState({
      usr: this.props.usr,
      email: this.props.email
    })
  }
  setDate = (lang) => {
    let options = { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    };
    if (this.props.date === null) {
      let date = new Date();
      date = date.toLocaleDateString(lang, options);
      return date;
    } else {
      let date = this.props.date
      date = date.toLocaleDateString(lang, options);
      return date;
    }
  }

  render() {
    if (this.props.menutype === "date") {
      return (
        <div id="MenuCenter">
            <span className="MenuCenterTxt">{this.setDate(this.props.locale)}</span>
            <div id="CalendarIcon" onClick={this.props.openCalendar} >
              <Icons name="calendar" />
            </div>
        </div>
      )
    } else if (this.props.menutype === "textonly") {
      return (
        <div id="MenuCenter">
            <span className="MenuCenterTxt">{this.props.txt}</span>
        </div>
      )
    } else if (this.props.menutype === "usr") {
      if (this.props.usr) {
        return (
          <div id="MenuCenterUsr">
              <span className="MenuCenterUsr">{this.props.usr}</span>
              <span className="MenuCenterEmail">{this.props.email}</span>
          </div>
        )
      } else {
          return (
            <div id="MenuCenterUsr">
                <span className="MenuCenterUsr">loading</span>
                <span className="MenuCenterEmail">loading</span>
            </div>
          )
        }
      } else if (this.props.menutype === "SelectedTab") {
        if (this.props.tab) {
          return (
            <div id="MenuCenterUsr">
                <span className="MenuCenterUsr">{this.props.tab}</span>
                <span className="MenuCenterEmail">{this.props.tabname}</span>
            </div>
          )
        } else {
        return (
          <div id="MenuCenterUsr">
              <span className="MenuCenterUsr">loading</span>
              <span className="MenuCenterEmail">loading</span>
          </div>
        )
      }
    }
  }
}


export default MenuCenter;


// WEBPACK FOOTER //
// ./src/Components/Menu/MenuCenter.js